import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {AiAssistantService, AssistantDefinition} from '../../services/ai-assistant.service';

@Component({
  selector: 'app-assistant-picker-screen',
  templateUrl: './assistant-picker-screen.component.html',
  styleUrls: ['./assistant-picker-screen.component.scss']
})
export class AssistantPickerScreenComponent implements OnInit {
  assistants: AssistantDefinition[];
  @Output() selectAssistantEvent: EventEmitter<AssistantDefinition> = new EventEmitter<AssistantDefinition>();

  constructor(private aiAssistantService: AiAssistantService) {
    this.assistants = this.aiAssistantService.assistants;
  }

  get assistantsLoaded() {
    return !!this.aiAssistantService.assistants;
  }

  ngOnInit(): void {
  }

  selectAssistant(assistant: AssistantDefinition) {
    this.selectAssistantEvent.emit(assistant);
  }
}
